import Vue from "vue";
import TitleMixin from "@/mixins/title";
import SpinnerMixin from "@/mixins/spinner";
export default Vue.extend({
    mixins: [TitleMixin, SpinnerMixin],
    data() {
        return {
            title: this.$t("acquisitionChannels.edit.title"),
            id: this.$route.params.id,
            acquisitionChannel: {},
            validationOptions: {
                rules: {
                    name: {
                        required: true,
                        rangeLength: [3, 50]
                    },
                    description: {
                        maxLength: 500
                    }
                }
            }
        };
    },
    methods: {
        edit() {
            return this.$store.dispatch("acquisitionChannel/edit", {
                id: this.id,
                acquisitionChannel: this.acquisitionChannel
            });
        },
        editSuccess() {
            this.$toast.showSuccessToast(this.$t("acquisitionChannels.edit.toastSuccessTitle"), this.$t("acquisitionChannels.edit.toastSuccessContent", {
                name: this.acquisitionChannel.name
            }));
            return this.$router.push("/acquisition-channels");
        },
        cancel() {
            return this.$router.push("/acquisition-channels");
        }
    },
    async mounted() {
        this.showSpinner();
        try {
            this.acquisitionChannel = await this.$store.dispatch("acquisitionChannel/get", {
                id: this.id
            });
            this.title += ` ${this.acquisitionChannel.name}`;
            this.hideSpinner();
        }
        catch (errors) {
            this.hideSpinner();
            this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                error: errors[0].message
            }));
            await this.$router.push("/acquisition-channels");
        }
    }
});
